import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const LoadingSpinner = ({ size = "1x" }) => (
  <FontAwesomeIcon size={size} icon={faSpinner} spin />
);

export default LoadingSpinner;
